/**
 * This component has been migrated to the Duo-UI library (https://gitlab.com/gitlab-org/duo-ui).
 *
 * Please use the corresponding component in Duo-UI going forward.
 * All future development and maintenance for Duo components should take place in Duo-UI.
 *
 * For more details, see the migration epic: https://gitlab.com/groups/gitlab-org/-/epics/15344 or reach out to the Duo-Chat team in #g_duo_chat.
 */

const CHAT_RESET_MESSAGE = '/reset';
const CHAT_CLEAR_MESSAGE = '/clear';
const CHAT_INCLUDE_MESSAGE = '/include';
const LOADING_TRANSITION_DURATION = 7500;
const DOCUMENTATION_SOURCE_TYPES = {
  HANDBOOK: {
    value: 'handbook',
    icon: 'book'
  },
  DOC: {
    value: 'doc',
    icon: 'documents'
  },
  BLOG: {
    value: 'blog',
    icon: 'list-bulleted'
  }
};
const MESSAGE_MODEL_ROLES = {
  user: 'user',
  system: 'system',
  assistant: 'assistant'
};
const SELECTED_CONTEXT_ITEMS_DEFAULT_COLLAPSED = true;

export { CHAT_CLEAR_MESSAGE, CHAT_INCLUDE_MESSAGE, CHAT_RESET_MESSAGE, DOCUMENTATION_SOURCE_TYPES, LOADING_TRANSITION_DURATION, MESSAGE_MODEL_ROLES, SELECTED_CONTEXT_ITEMS_DEFAULT_COLLAPSED };
